const memberKeys = {
  all: ['member'] as const,
  members: () => [...memberKeys.all, 'members'] as const,
};

export { memberKeys };
